import React, { useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Logo } from "../../components/tabon/Logo";
import { api, formatError } from "../../lib/api";

export default function SASetPassword() {
  const { token } = useParams();
  const navigate = useNavigate();
  const [pw, setPw] = useState("");
  const [pw2, setPw2] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (pw.length < 6) { toast.error("Password must be at least 6 characters"); return; }
    if (pw !== pw2) { toast.error("Passwords don't match"); return; }
    setLoading(true);
    try {
      await api.post("/admin/auth/set-password", { token, password: pw });
      toast.success("Password set. Please sign in.");
      navigate("/admin/login");
    } catch (err) { toast.error(formatError(err)); }
    finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen tb-hero-gradient flex items-center justify-center px-4">
      <div className="absolute inset-0 tb-grid-bg opacity-30 pointer-events-none" />
      <div className="relative w-full max-w-md tb-fade-up">
        <div className="flex flex-col items-center mb-8">
          <Logo size="xl" />
          <span className="mt-3 text-[10px] font-bold uppercase tracking-wider bg-white/10 text-[#A0A0A0] border border-white/15 rounded-full px-3 py-1">
            Accept Superadmin Invite
          </span>
        </div>
        <form onSubmit={submit} className="bg-[#1A1A1A] border border-white/10 rounded-xl p-7 flex flex-col gap-4">
          <h1 className="text-2xl font-bold">Set your password</h1>
          <p className="text-sm text-[#A0A0A0] -mt-2">Welcome to TabOn founding team.</p>
          <div>
            <label className="text-xs font-bold uppercase tracking-wider text-[#A0A0A0] mb-1.5 block">Password</label>
            <input
              data-testid="sa-set-pw" type="password" required minLength={6}
              value={pw} onChange={(e) => setPw(e.target.value)}
              className="w-full bg-[#0A0A0A] border border-white/10 rounded-lg px-4 py-3 text-white focus:border-[#9D00FF]"
            />
          </div>
          <div>
            <label className="text-xs font-bold uppercase tracking-wider text-[#A0A0A0] mb-1.5 block">Confirm Password</label>
            <input
              data-testid="sa-set-pw2" type="password" required minLength={6}
              value={pw2} onChange={(e) => setPw2(e.target.value)}
              className="w-full bg-[#0A0A0A] border border-white/10 rounded-lg px-4 py-3 text-white focus:border-[#9D00FF]"
            />
          </div>
          <button
            type="submit" disabled={loading} data-testid="sa-set-pw-submit"
            className="tb-glow bg-[#9D00FF] hover:bg-[#8C00E6] disabled:opacity-60 text-white font-semibold rounded-lg py-3"
          >
            {loading ? "Saving…" : "Set Password & Continue"}
          </button>
        </form>
      </div>
    </div>
  );
}
